import { getCustomerSlug } from "@components/Dwolla"
import { ENTITY, INDIVIDUAL, JOINT, SDIRA } from "@api/services/investments/shapes/ProfileTypeEnum"

const getProfileId = investment => {
  const {
    investorAccountId,
    profileType,
    profileJoint,
    profileEntity,
    profileSdira
  } = investment

  const isIndividual = profileType === INDIVIDUAL;
  const isJoint = profileType === JOINT;
  const isEntity = profileType === ENTITY;
  const isSdira = profileType === SDIRA;

  if (isIndividual) {
    return `${investorAccountId}-${profileType}`
  }

  if (isJoint) {
    const { jointGivenName, jointFamilyName } = profileJoint
    const normalizedName = getCustomerSlug(`${jointGivenName}-${jointFamilyName}`)

    return `${investorAccountId}-${profileType}-${normalizedName}`
  }

  if (isEntity) {
    const { name } = profileEntity
    const normalizedName = getCustomerSlug(name)

    return `${investorAccountId}-${profileType}-${normalizedName}`
  }

  if (isSdira) {
    const { name } = profileSdira
    const normalizedName = getCustomerSlug(name)

    return `${investorAccountId}-${profileType}-${normalizedName}`
  }

  throw new Error(`Profile type ${profileType} is not supported`)
}

export default getProfileId
